export enum VisaoRelatorioMarketShare {
    DAY = "DAY",
    MTD = "MTD",
    YTD = "YTD"
}
